import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'luxury';
  fullWidth?: boolean;
  withIcon?: boolean;
  withSparkle?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  withIcon = false,
  withSparkle = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = `
    relative inline-flex items-center justify-center gap-2
    px-8 py-4 text-base font-semibold tracking-wide
    rounded-full overflow-hidden
    transition-all duration-500 ease-out
    focus:outline-none focus:ring-2 focus:ring-offset-2
    disabled:opacity-50 disabled:cursor-not-allowed
    transform hover:-translate-y-1 active:translate-y-0
  `;
  const variants = {
    primary: `
      bg-gradient-to-r from-[#C9A86A] via-[#D4B87A] to-[#C9A86A]
      bg-[length:200%_100%] animate-gradient
      text-white font-semibold
      shadow-[0_10px_40px_-10px_rgba(201,168,106,0.5)]
      hover:shadow-[0_20px_50px_-10px_rgba(201,168,106,0.6)]
      focus:ring-[#C9A86A]
      btn-premium
    `,
    secondary: `
      bg-gradient-to-r from-[#3A3A3A] via-[#4A4A4A] to-[#3A3A3A]
      bg-[length:200%_100%]
      text-white
      shadow-[0_10px_40px_-10px_rgba(58,58,58,0.4)]
      hover:shadow-[0_20px_50px_-10px_rgba(58,58,58,0.5)]
      focus:ring-[#3A3A3A]
      btn-premium
    `,
    outline: `
      bg-transparent
      border-2 border-[#C9A86A]
      text-[#C9A86A]
      hover:bg-[#C9A86A] hover:text-white
      shadow-[0_0_0_0_rgba(201,168,106,0)]
      hover:shadow-[0_10px_40px_-10px_rgba(201,168,106,0.4)]
      focus:ring-[#C9A86A]
    `,
    luxury: `
      bg-gradient-to-r from-[#C9A86A] via-[#E8D5D0] to-[#C9A86A]
      bg-[length:300%_100%] animate-gradient
      text-[#3A3A3A] font-bold
      shadow-[0_10px_40px_-10px_rgba(201,168,106,0.5),inset_0_1px_0_rgba(255,255,255,0.3)]
      hover:shadow-[0_20px_60px_-10px_rgba(201,168,106,0.7),inset_0_1px_0_rgba(255,255,255,0.4)]
      focus:ring-[#C9A86A]
      btn-premium
      animate-pulse-glow
    `
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-195">
      {/* Shimmer overlay */}
      <span className="absolute inset-0 overflow-hidden rounded-full" data-id="element-196">
        <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:translate-x-full transition-transform duration-1000" data-id="element-197" />
      </span>

      {/* Content */}
      <span className="relative flex items-center gap-2" data-id="element-198">
        {withSparkle && <Sparkles className="w-5 h-5 animate-pulse" data-id="element-199" />}
        {children}
        {withIcon && <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-200" />}
      </span>
    </button>;
}